import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          lighten4: "#0098da",
          lighten2: "#495aff",
          base: "#031f41",
        },
        secondary: "#1E1E1E",
        accent: {
          lighten2: "#00a859",
          base: "#003538",
        },
        success: "#a8cf46",
        warning: {
          base: "#fbb12f",
          darken2: "#a45e4d",
          darken4: "#ed3137",
        },
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "fa",
  },
});
